import React, { FC, useMemo } from "react";
import { Trans } from "react-i18next";
import { SimpleTitle } from "../styles";
import { PUBLISHED_TEAM_STATUS, REJECTED_TEAM_STATUS } from "shared/helpers/teamsStatus";

const getActionInfo = (item: any) => {
    const action = item?.actions?.[0] || {};
    const info = action?.teamStatusChangeInfo || {};

    return {
        action,
        info,
    };
};

const getTeamName = (action: any, info: any) => {
    if (typeof info?.teamName === "string" && info.teamName.trim()) return info.teamName;
    if (typeof action?.teamName === "string" && action.teamName.trim()) return action.teamName;
    if (typeof info?.name === "string" && info.name.trim()) return info.name;
    if (typeof action?.entityName === "string" && action.entityName.trim()) return action.entityName;
    return "";
};

const getTeamId = (action: any, info: any) =>
    info?.teamId ?? action?.teamId ?? action?.entityId ?? '';

export const getTeamStatusChangeTitle = (item: any) => {
    const { action, info } = getActionInfo(item);
    const teamName = getTeamName(action, info);
    const status = info?.status; 

    if (!teamName) return null;

    const teamId = getTeamId(action, info);
    const designerId = item?.recipientAccountId ?? '';
    const showcaseTeamId  = info?.parentTeamRoute ?? '';
    const teamPageHref = teamId ? info?.route : '';
    const profileHref = designerId ? `${window.location.origin}/account/${designerId}` : '';
    const showcaseHref = showcaseTeamId
    let langKey = 'notifications.team_created';

    if (status === PUBLISHED_TEAM_STATUS) {
        langKey = 'notifications.team_published';
    }

    if (status === REJECTED_TEAM_STATUS) {
        langKey = 'notifications.team_created_rejected';
    }


    return (
        <Trans
            i18nKey={langKey}
            values={{ teamName }}
            components={{
                teamLink: teamPageHref ? (
                    <a href={teamPageHref} />
                ) : (
                    <span />
                ),
                designerLink: profileHref ? (
                    <a href={profileHref} />
                ) : (
                    <span />
                ),
                showcaseLink: showcaseHref ? (
                    <a href={showcaseHref} />
                ) : (
                    <span />
                ),
            }}
        />
    );
};

export const NotificationTeamCreatedResult: FC<{ item: any }> = ({ item }) => {
    const title = useMemo(() => getTeamStatusChangeTitle(item), [item]);

    if (!title) return null;

    return (
        <SimpleTitle>
            {title}
        </SimpleTitle>
    );
};
import React, { FC, useMemo } from "react";
import { Trans } from "react-i18next";
import { SimpleTitle } from "../styles";
import { PUBLISHED_TEAM_STATUS, REJECTED_TEAM_STATUS } from "shared/helpers/teamsStatus";

const getActionInfo = (item: any) => {
    const action = item?.actions?.[0] || {};
    const info = action?.teamStatusChangeInfo || {};

    return {
        action,
        info,
    };
};

const getTeamName = (action: any, info: any) => {
    if (typeof info?.teamName === "string" && info.teamName.trim()) return info.teamName;
    if (typeof action?.teamName === "string" && action.teamName.trim()) return action.teamName;
    if (typeof info?.name === "string" && info.name.trim()) return info.name;
    if (typeof action?.entityName === "string" && action.entityName.trim()) return action.entityName;
    return "";
};

const getTeamId = (action: any, info: any) =>
    info?.teamId ?? action?.teamId ?? action?.entityId ?? '';

export const getTeamStatusChangeTitle = (item: any) => {
    const { action, info } = getActionInfo(item);
    const teamName = getTeamName(action, info);
    const status = info?.status; 

    if (!teamName) return null;

    const teamId = getTeamId(action, info);
    const designerId = item?.recipientAccountId ?? '';
    const showcaseTeamId  = info?.parentTeamRoute ?? '';
    const teamPageHref = teamId ? info?.route : '';
    const profileHref = designerId ? `${window.location.origin}/account/${designerId}` : '';
    const showcaseHref = showcaseTeamId
    let langKey = 'notifications.team_created';

    if (status === PUBLISHED_TEAM_STATUS) {
        langKey = 'notifications.team_published';
    }

    if (status === REJECTED_TEAM_STATUS) {
        langKey = 'notifications.team_created_rejected';
    }


    return (
        <Trans
            i18nKey={langKey}
            values={{ teamName }}
            components={{
                teamLink: teamPageHref ? (
                    <a href={teamPageHref} />
                ) : (
                    <span />
                ),
                designerLink: profileHref ? (
                    <a href={profileHref} />
                ) : (
                    <span />
                ),
                showcaseLink: showcaseHref ? (
                    <a href={showcaseHref} />
                ) : (
                    <span />
                ),
            }}
        />
    );
};

export const NotificationTeamCreatedResult: FC<{ item: any }> = ({ item }) => {
    const title = useMemo(() => getTeamStatusChangeTitle(item), [item]);

    if (!title) return null;

    return (
        <SimpleTitle>
            {title}
        </SimpleTitle>
    );
};
